import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "notification-container" }

import { useUiStore } from '@/stores/uiStore';

export default /*@__PURE__*/_defineComponent({
  __name: 'NotificationDisplay',
  setup(__props) {

const uiStore = useUiStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_TransitionGroup, {
      name: "notification",
      tag: "div"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(uiStore).notifications, (notification) => {
          return (_openBlock(), _createElementBlock("div", {
            key: notification.id,
            class: "notification-toast"
          }, _toDisplayString(notification.message), 1))
        }), 128))
      ]),
      _: 1
    })
  ]))
}
}

})